<div class="full-height layout-column">

  <!--Table-->
  <div *ngIf="!!agents?.length && !isInitialLoading"
       class="flex layout-column bringoz-table bringoz-table-sticky scrollable ">

      <!--Table Header-->
      <div id="header-availability-table" class="tr layout-row layout-align-start-center ">
        <div class="layout-row layout-align-center-center th sticky ">
          <span class="br-body-1 font-weight-600 gray-100 " translate>Agent</span>
        </div>

        <div *ngFor="let date of dates"
             class="th flex layout-row layout-align-center-center day-col text-ellipsis">
        <span class="br-body-1 font-weight-600 gray-100">
          {{ dateInfo.get(date)?.dayName }} {{ dateInfo.get(date)?.formattedDate }}
        </span>
        </div>
      </div>

      <!--Table Body-->
      <div class="flex layout-column rows-container full-height">
        <!--Repeater-->
        <div class="full-height flex layout-column">
          <cdk-virtual-scroll-viewport [itemSize]="80" class="flex layout-column viewport cdk-availability"
                                       (scroll)="getNextBatch()">
            <app-availability-table-row *cdkVirtualFor="let agent of agents; let index = index"
                                        [agent]="agent"
                                        [index]="index"
                                        [dates]="dates"
                                        [resourcesByDate]="resourcesByAgent.get(agent.id)"
                                        [conflictingResourceIds]="conflictingResourceIds"
                                        [visitPlan]="visitPlan"
                                        [visitScheduleId]="visitScheduleId"
                                        [zoneId]="zoneId"
                                        (resourcesUpdated)="onResourcesUpdated($event)"
                                        (disableAllDays)="onDisableAllDays($event)"
                                        class="item flex layout-column">
            </app-availability-table-row>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>

  </div>

  <!--Empty State-->
  <div *ngIf="!agents?.length && !isLoading"
       class="flex-100 full-height layout-row layout-align-center-center fade-element-in-only">
    <app-empty-state src="assets/images/empty_state/empty_state_agent.png"
                     text="No agents found">

    </app-empty-state>
  </div>

  <!--Loading Mode - circular spinner only until the first batch has painted-->
  <div *ngIf="isInitialLoading"
       class="flex-100 layout-row layout-align-center-center">
    <div class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <!--Loading Mode - linear progress while fetching the next batch on scroll-->
  <app-bringoz-linear-progress *ngIf="isLoading && isInitialized"></app-bringoz-linear-progress>

</div>
